import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TextUtils } from 'src/app/core/utils/TextUtils';


@Component({
  selector: 'app-email-input',
  template: `
      <ng-content select=".input-group-prepend"></ng-content>
      <div class="horizontal-container">
        <input
          [id]="name  + '-username'"
          [placeholder]="placeholder | transloco"
          [formControl] = "$any(form.get('username'))"
          [readonly]="readonly"
          [name]="name"
          appInputValidity
          [class]="inputClass"
          (blur)="blurred.emit($event)"
          [style]="inputStyles"
        />
        <div *ngIf="hasDomain">
          <input
            [id]="name  + '-domain'"
            [formControl] = "$any(form.get('domain'))"
            [readonly]=true
            appInputValidity
            [class]="inputClass"
            (blur)="blurred.emit($event)"
            [style]="inputStyles"
          />
        </div>
      </div>
      <ng-content select=".input-group-append"></ng-content>
      <app-input-errors class="input-error" [control]="emailControl"></app-input-errors>
  `,
  styleUrls: ['./email-input.component.scss']
})
export class EmailInputComponent implements OnInit, OnDestroy {
  @Input() name = '';
  @Input() emailControl: AbstractControl;
  @Input() readonly = false;
  @Input() placeholder = '';
  @Input() inputClass = 'form-control';
  @Input() inputStyles = '';
  @Input() hasDomain = false;
  @Output() blurred = new EventEmitter<FocusEvent>();

  form = this.fb.group({
    'username': new FormControl(''),
    'domain': new FormControl('')
  });
  formChanged: Subscription = null;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const email = this.emailControl.value as string

    const username = TextUtils.getEmailUsername(email)
    const domain = TextUtils.getEmailDomain(email)

    this.form.patchValue({
      'username': username,
      'domain': domain
    })

    this.formChanged = this.form.valueChanges.subscribe( value => {
      this.updateEmail(value)
    })
  }

  private updateEmail(value: any) {
    if (value) {
      const username = value.username != null ? value.username : ''
      const domain = value.domain != null ? value.domain : ''
      const email = `${username}${domain}`

      this.emailControl.setValue(email)
    }
  }

  ngOnDestroy(): void {
    this.formChanged?.unsubscribe()
  }
}